<template>
	<div>
		<Loading v-if="loading" />
		<Header />
		<TitlePage />
		<!-- UI DESKTOP -->
		<template v-if="!isMobile">
			<EditListingDesktop
				:key="$route.name === 'AddListing' ? 'addListing' : 'editListing'"
				@loading="loading = $event"
			/>
		</template>
		<!-- UI MOBILE -->
		<template v-else>
			<EditListingMobile @loading="loading = $event" />
		</template>
		<Footer :adsFooter="adsFooter"/>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import EditListingDesktop from '@/components/listing/editListing/EditListingDesktop';
import EditListingMobile from '@/components/listing/editListing/mobile/EditListingMobile';

import Loading from '@/components/ui/loading';
import Header from '@/components/ui/header';
import Footer from '@/components/ui/footer';
import TitlePage from '@/components/ui/titlePage';

export default {
	components: {
		EditListingDesktop,
		EditListingMobile,
		Header,
		Footer,
		TitlePage,
		Loading
	},
	data() {
		return {
			loading: false,
			adsFooter: null,
		};
	},
	computed: {
		...mapGetters('UserController', ['isMobile'])
	},
	created(){
		let locationId = 9;
		if(this.isMobile){
			locationId=49;
		}
		this.getFooterAds(locationId);
	},
	methods:{
		...mapActions("AdsController", [
			"GETADS_FOR_PUBLIC_WEBSITE",
			"CLICK_BANNERADS"
		]),
		getFooterAds(locationId){
			console.log("locationId",locationId);
			this.GETADS_FOR_PUBLIC_WEBSITE({
				id: locationId
			}).then(({ data }) => {
				console.log("data",data)
			if (data) {
				this.adsFooter = data;
				this.$forceUpdate();
			}
			});
		},
	},
	destroyed(){
		console.log("destroyed search")
		this.adsFooter=null
	}
	
};
</script>

<style lang="scss"></style>
